function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef, useContext, useCallback } from 'react';
import styled from 'styled-components';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import globalNavLogEvent from '../../utils/globalNavLogEvent.js';
import UrlContext, { DEFAULT_BASE_URL } from '../GlobalNav/context/UrlContext.js';
import { jsx } from 'react/jsx-runtime';
const getParsedUrl = ({
  url,
  baseUrl
}) => {
  if (url.startsWith(DEFAULT_BASE_URL) && baseUrl !== DEFAULT_BASE_URL) {
    // Make url relative
    const relativeUrl = url.replace(DEFAULT_BASE_URL, baseUrl);
    // If replaced url doesnt start with a slash, then the link didnt include a trailing slash.
    // We handle this case by appending a slash to the beginning of the string
    return `${relativeUrl[0] !== '/' ? '/' : ''}${relativeUrl}`;
  }
  return url;
};
const Link = /*#__PURE__*/forwardRef(({
  children,
  to,
  className,
  logEvents,
  title,
  testID,
  onClick,
  onKeyDown,
  ariaControls,
  target,
  eventProps = {},
  clickEventName = 'global_nav_link'
}, ref) => {
  const _useContext = useContext(UrlContext),
    baseUrl = _useContext.baseUrl,
    onUrlChange = _useContext.onUrlChange;
  const parsedUrl = getParsedUrl({
    url: to,
    baseUrl
  });

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
  const handleClick = () => {
    if (logEvents) {
      globalNavLogEvent(clickEventName, _objectSpread({
        action: ActionType.click,
        componentType: ComponentType.link,
        key: to || title || 'unknown'
      }, eventProps));
    }
    if (onUrlChange) {
      onUrlChange(parsedUrl);
    }
    if (onClick) {
      onClick();
    }
  };
  const additionalProps = {};
  if (!onClick) {
    additionalProps.href = parsedUrl;
  }
  const handleOnMouseEnter = useCallback(() => {
    logEvents && globalNavLogEvent('global_nav_link', {
      action: ActionType.hover,
      componentType: ComponentType.link,
      key: to
    });
  }, [logEvents, to]);
  return /*#__PURE__*/jsx(StyledLink, _objectSpread(_objectSpread(_objectSpread({
    target: target,
    ref: ref,
    as: onClick ? 'span' : 'a',
    onClick: handleClick,
    onMouseEnter: handleOnMouseEnter,
    className: className,
    title: title,
    onKeyDown: onKeyDown,
    "data-testid": testID
  }, ariaControls ?? {}), additionalProps), {}, {
    children: children
  }));
});
const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  font-family: ${({
  theme
}) => theme.fontFamily.sans};
  color: ${({
  theme
}) => theme.color.textAccent};
`;
export { Link as default, getParsedUrl };
//# sourceMappingURL=Link.js.map
